import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material'
import { CompanyAeComponent } from '../company-ae/company-ae.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  @ViewChild(CompanyAeComponent) companyAeComponent: CompanyAeComponent

  constructor() { }

  ngOnInit() {
  }

  onTabClick(event: MatTabChangeEvent) {
    switch (event.index) {
      case 0:
        this.companyAeComponent.ngOnInit()
        break
      case 1:
        // this.boardShareholderComponent.getDetailBoardShareholder()
        // break
      case 2:
        // this.additionalInfoComponent.ngOnInit()
        // break
      default:
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/admin/admin.component.ts